const CardDeck = 
{
    Civil: "Civil",
    Military: "Military"
}

const CivilCardTypes = 
{
    Technology: "Technology",
    Action: "Action",
    Leader: "Leader",
    Wonder: "Wonder",
}

const MilitaryCardTypes = 
{
    Event: "Event",
    Territory: "Territory",
    Bonus: "Bonus",
    Tactic: "Tactic",
    Aggression: "Aggression",
    War: "War",
    Pact: "Pact"
}

module.exports = 
{
    CardDeck,
    CivilCardTypes,
    MilitaryCardTypes,
}